import type { JpegQuality } from '../types'

const OPTIONS: { value: JpegQuality; label: string }[] = [
  { value: 70, label: 'Smaller' },
  { value: 85, label: 'Balanced' },
  { value: 95, label: 'Best' },
]

interface QualitySelectorProps {
  value: JpegQuality
  onChange: (value: JpegQuality) => void
}

export default function QualitySelector({ value, onChange }: QualitySelectorProps) {
  return (
    <fieldset className="control">
      <legend className="control-head">
        <span>JPG quality</span>
        <span>Compression level</span>
      </legend>
      <div className="segment" role="radiogroup" aria-label="JPG quality">
        {OPTIONS.map((opt) => (
          <button
            key={opt.value}
            type="button"
            role="radio"
            aria-checked={value === opt.value}
            className={value === opt.value ? 'selected' : ''}
            onClick={() => onChange(opt.value)}
          >
            {opt.label}
          </button>
        ))}
      </div>
    </fieldset>
  )
}
